module.exports = __webpack_public_path__ + "img/icon_arrow_next.8bd062d3.png";